import React from "react";

import { AbtaLogo, AstaLogo, AtolLogo, LazyLoadImage, LineDots, LinkButton } from "../../../core/atoms/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import TrustFiguresBlock from "./trustFiguresBlock";
import TrustIconList from "./trustIconList";

import "./trustSection.scss";

interface Props {
  country: ICountry;
}

export class TrustSection extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render(): JSX.Element {
    const { country } = this.props;

    // #1531 Enable selection of trust section header
    const headerImage = (country.images || []).find(x => x.locationImageType === LocationImageType.TrustHeader) || country.heroImage;

    const press = [
      { alt: "National Geographic", img: "NatGeo_logo_black.svg" },
      { alt: "The Guardian", img: "Guardian_logo_black.svg" },
      { alt: "The Daily Telegraph", img: "Telegraph_logo_black.svg" },
      { alt: "BBC", img: "BBC_logo_black.svg" },
      { alt: "Financial Times", img: "FinancialTimes_logo_black.svg" },
    ];

    const protections = [
      <AtolLogo type="dark" />,
      <AbtaLogo type="dark" />,
      <AstaLogo type="dark" />,
    ];

    return (
      <div className="trust-section">
        <div className="trust-section-header">
          <LazyLoadImage src={headerImage} alt={headerImage.meta || ""}/>
        </div>

        <div className="columns is-centered is-marginless">
          <div className="column is-10 is-paddingless is-flex-tablet trust-section-body">
            <div className="trust-section-figures">
              <TrustFiguresBlock country={this.props.country} />
            </div>

            <div className="trust-section-press">
              <TrustIconList title="You may have seen us in" iconList={press} className="press" />
            </div>

            <div className="trust-section-cta-protections">

              <div className="trust-protections">
                <TrustIconList title="Book with confidence" iconList={protections} className="protections" />
              </div>

              <div className="trust-cta">
                <h2>Want to go?
                <div className="trust-dots-mobile">
                    <LineDots height="28" x1="50%" y1="10%" x2="50%" y2="100%" />
                  </div>
                  <div className="trust-dots-desktop">
                    <LineDots x1="-3px" y1="50%" x2="100%" y2="50%" />
                  </div>
                </h2>
                <LinkButton
                  to={WebRoutes.enquiryForm({ locationSlug: this.props.country.slug, campaign: "country-page-trust-section" })}
                  className="primary-button"
                >
                  Plan my trip
                </LinkButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
